import {Directive, Inject, Optional, Self, Attribute, HostListener, inject, Injector, OnInit} from '@angular/core';


import { FormComponent } from './form.component';
import {applyFilterOnField, Parent, parseValueByType, register, ToDatePipe} from "@wm/components-base";
import {LivetableComponent} from "../livetable/livetable.component";
import {DataType, isDefined} from "@wm/core";
import {get, isString, set} from "lodash-es";

const isTimeType = (field: any) => field.widgettype === DataType.TIME || (field.type === DataType.TIME && !field.widgettype);
const getValidTime = (val: any) => {
  if (val) {
    const date = (new Date()).toDateString();
    return (new Date(`${date} ${val}`)).getTime();
  }
  return undefined;
};

@Directive({
    selector: '[wmLiveForm]',
    standalone: true
})
export class LiveFormDirective implements OnInit {
    static initializeProps = register('wm-liveform');
    isLiveform: boolean = true;
    constructor(
        @Self() @Inject(FormComponent) private form: FormComponent,
        @Optional() liveTable: LivetableComponent,
        @Attribute('formlayout') formlayout: string
    ) {
        // If parent live table is present and this form is first child of live table, set this form instance on livetable
        if (liveTable && !this.form.parentForm) {
            this.form._liveTableParent = liveTable;
            this.form.isLayoutDialog = liveTable.isLayoutDialog;
            liveTable.onFormReady(this.form);
        } else {
            this.form.isLayoutDialog = formlayout === 'dialog';
        }
        this.form.isLiveform = this.isLiveform;

        // set(form, 'setPrimaryKey', this.setPrimaryKey.bind(this));
        // set(form, 'constructDataObject', this.constructDataObject.bind(this));
        set(form, 'changeDataObject', this.setFormData.bind(this));
        set(form, 'setFormData', this.setFormData.bind(this));
        // form.findOperationType = this.findOperationType.bind(this);
        set(form, 'clearData', this.clearData.bind(this));
        set(form, 'onFieldDefaultValueChange', this.onFieldDefaultValueChange.bind(this));
        // form.onDataSourceChange = this.onDataSourceChange.bind(this);
        set(form, 'onFieldValueChange', this.onFieldValueChange.bind(this));
        // form.submitForm = this.submitForm.bind(this);
        set(form, 'form_registerFormFields', form.registerFormFields);
        set(form, 'registerFormFields', this.registerFormFields.bind(this));
    }

    ngOnInit() {
      this.form.setUpdateMode();
    }

    registerFormFields(formField: any) {
    // const formFields = this.form.getFormFields();
      (this.form as any).form_registerFormFields(formField);
    // if (this.form.isDataSourceUpdated) {
    //   // this._updateFieldOnDataSourceChange(formField, formFields);
    // }
  }

  onFieldValueChange(field: any, nv: any) {
    // applyFilterOnField(this.form.datasource, field.widget, this.form.formFields, nv);
  }

  onFieldDefaultValueChange(field: any, nv: any) {
    // In Edit, do  not set default values
    // if (this.form.operationType === 'update') {
    //   return;
    // }
    // Set the default value only if it exists.
    if (isDefined(nv) && nv !== null && nv !== '' && nv !== 'null') {
      field.value = parseValueByType(nv, field.type, field.widgettype, field.trailingzero);
    } else {
      field.value = undefined;
    }
  }

  clearData() {
    // this.form.toggleMessage(false);
    // this.form.emptyDataModel();
  }

  setFormData(dataObj: any, formFields?: any) {
    if (!dataObj) {
      return;
    }
    formFields = formFields || this.form.formFields;
    formFields.forEach((field: any) => {
      const value = get(dataObj, field.key || field.name);
      if (isTimeType(field)) {
        field.value = getValidTime(value);
      } else if (field.type === DataType.BLOB) {
        // this.form.resetFileUploadWidget(field, true);
        // field.href  = this.getBlobURL(dataObj, field.key, value);
        field.value = isString(value) ? '' : value;
      } else {
        this.form.setFieldValue(field, dataObj);
      }
    });
    this.savePrevDataValues();
    // this.form.constructDataObject();
  }

  savePrevDataValues() {
    this.form.prevDataValues = this.form.formFields.map((obj: any) => {
      return {'key': obj.key, 'value': obj.value};
    });
  }

  // constructDataObject(isPreviousData?) {
  //   const dataObject = this.getDataObject();
  //   const formName = this.form.name;
  //   let formFields;
  //   formFields = isPreviousData ? this.form.prevformFields : this.form.getFormFields();
  //   formFields.forEach(field => {
  //     let dateTime,
  //       fieldValue;
  //     const fieldTarget = _.split(field.key, '.');
  //     const fieldName = fieldTarget[0] || field.key;
  //
  //     /*collect the values from the fields and construct the object*/
  //     /*Format the output of date time widgets to the given output format*/
  //     if ((field.widgettype && isDateTimeType(field.widgettype)) || isDateTimeType(field.type)) {
  //       if (field.value) {
  //         dateTime = getValidDateObject(field.value);
  //         if (field.outputformat === DataType.TIMESTAMP || field.type === DataType.TIMESTAMP) {
  //           fieldValue = field.value ? dateTime : null;
  //         } else if (field.outputformat) {
  //           fieldValue = this.datePipe.transform(dateTime, field.outputformat);
  //         } else {
  //           fieldValue = field.value;
  //         }
  //       } else {
  //         fieldValue = undefined;
  //       }
  //     } else if (field.type === DataType.BLOB) {
  //       fieldValue = getFiles(formName, fieldName + '_formWidget', field.multiple);
  //     } else if (field.type === DataType.LIST) {
  //       fieldValue = field.value || undefined;
  //     } else {
  //       fieldValue = (field.value === null || field.value === '') ? undefined : field.value;
  //     }
  //
  //     if (fieldTarget.length === 1) {
  //       dataObject[fieldName] = fieldValue;
  //     } else {
  //       dataObject[fieldName] = dataObject[fieldName] || {};
  //       dataObject[fieldName][fieldTarget[1]] = fieldValue;
  //     }
  //   });
  //   if (!isPreviousData) {
  //     this.form.updateFormDataOutput(dataObject);
  //     return this.form.dataoutput;
  //   }
  //   return dataObject;
  // }
}
